import * as yup from "yup";
import { NewsletterFormValues } from "./interfaces";

export const initialValues: NewsletterFormValues = {
  email: "",
  privacyPolicy: false,
  newsletters: false,
};

export const validationSchema = (): yup.SchemaOf<NewsletterFormValues> =>
  yup.object().shape({
    email: yup.string().email().required(),
    privacyPolicy: yup.bool().required().oneOf([true], " "),
    newsletters: yup.bool().required().oneOf([true], " "),
  });
